module.exports = __webpack_public_path__ + "img/Group 3181.8d6ead3e.png";